import PrivateLeagueBasicCreateRequestBody from "./PrivateLeagueBasicCreateModel";

export default class PrivateLeagueCreateModel extends PrivateLeagueBasicCreateRequestBody {
  public type: string = "PRIVATE";
}
